import React, { useState, useEffect } from 'react';

import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { WithApp } from 'contexts/appContext';
import { wsFindBy } from 'services/WService.js';
import { wsGetAll } from 'services/WService';

export default WithApp(function ModalCuotaProvider(props) {
  const cuota = props.model;

  const [dataChanging, setDataChanging] = useState({});
  const [coverages, setCoverages] = useState([]);
  
  function handleChange(field, value) {
    setDataChanging(prev => ({ ...prev, [field]: value }));
  }

  async function listCoverage() {
    let response = await wsGetAll('sale/cobertura-colgate');
    if (response.success) setCoverages(response.data);
  }

  useEffect(() => {
    if (cuota.open) {
      if (!cuota.id) listCoverage();
      setDataChanging(cuota);
    }
  }, [cuota.open]);

  return (
    <>
      <Modal
        title={`Cuota de grupo`}
        model={ cuota }
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        entity='sale/group-colgate'
        dataForce={{
          id_cobertura: dataChanging.id_cobertura
        }}
      >
        {!cuota.id &&
          <Autocomplete
          disableClearable
          options={coverages}
          getOptionLabel={(item) => `${item.description}`}
          renderInput={(params) => (
            <TextField {...params} label="Coberturas bimestrales" margin="normal" required />
          )}
          onChange={(e, item) => handleChange('id_cobertura', item?.id)}
          value={coverages.find(coverage => coverage.id === dataChanging.id_cobertura) || null}
          />
        }
        <TextField
          label="Cuota"
          fullWidth
          type="number"
          name="cuota"
          margin="normal"
          defaultValue={!!cuota ? cuota.cuota : ''}
          onChange={(e) => handleChange('cuota', e.target.value)}
          required
        />
        <TextField
          label="Descripción de la cuota"
          fullWidth
          type="text"
          name="description"
          margin="normal"
          defaultValue={!!cuota ? cuota.description : ''}
          onChange={(e) => handleChange('description', e.target.value)}
          required
        />
      </Modal>
    </>
  );
});
